import { z } from 'zod';
import { EVENT_TYPES, MAX_URL_LEN, type EventType } from './constants.js';

/** §4.1 — her olayda zorunlu zarf. */
export interface EventEnvelope {
  v: 1;
  /** proje id ("prj_" + nanoid12) */
  pid: string;
  /** anonim kullanıcı id — SDK üretir, 1st-party localStorage, 13 ay. consent(false) modunda boş. */
  aid: string;
  /** oturum id — SDK üretir, 30 dk inaktivitede yenilenir */
  sid: string;
  /** istemci epoch ms */
  ts: number;
  /** oturum içi monoton artan sıra */
  seq: number;
  type: EventType;
  /** path + query (origin'siz), maks 512 karakter */
  url: string;
  /** referrer (yalnızca ilk pageview'da dolu) */
  ref?: string;
  /** tipe özgü, §4.2 */
  props: Record<string, unknown>;
}

export const envelopeSchema = z.object({
  v: z.literal(1),
  pid: z.string().min(1).max(64),
  // consent(false) → cookieless mod: aid üretilmez, boş string gelir.
  aid: z.string().max(128),
  sid: z.string().max(128),
  ts: z.number().int().finite(),
  seq: z.number().int().nonnegative(),
  type: z.enum(EVENT_TYPES),
  url: z.string().max(MAX_URL_LEN),
  ref: z.string().max(MAX_URL_LEN).optional(),
  props: z.record(z.unknown()),
});

export type EnvelopeInput = z.infer<typeof envelopeSchema>;
